export const translations = {
  fr: {
    brand: "Naydars", tagline: "L'immobilier d'Algérie, simplement",
    heroTitle: "Trouvez votre prochain chez-vous",
    heroSub: "Appartements, maisons et terrains résidentiels — partout en Algérie.",
    search: "Rechercher", buy: "Acheter", rent: "Louer",
    propertyType: "Type", location: "Lieu", budget: "Budget max",
    anyBudget: "Tous prix", allTypes: "Tous", allWilayas: "Toute l'Algérie",
    apartment: "Appartement", house: "Maison", land: "Terrain",
    featured: "Sélection Naydars", featuredSub: "Les biens les plus remarquables",
    viewAll: "Voir tout", recentListings: "Dernières annonces",
    whyUs: "Pourquoi Naydars",
    trust1Title: "Annonces vérifiées", trust1Desc: "Chaque annonce est contrôlée avant publication.",
    trust2Title: "Contact direct", trust2Desc: "WhatsApp ou téléphone, sans intermédiaire.",
    trust3Title: "Prix transparents", trust3Desc: "Affichage en DA avec équivalent EUR.",
    login: "Se connecter", register: "S'inscrire", logout: "Déconnexion",
    postAd: "Publier", myAds: "Mes annonces", dashboard: "Tableau de bord",
    rooms: "Pièces", bathrooms: "SDB", surface: "Surface",
    filters: "Filtres", minPrice: "Prix min", maxPrice: "Prix max",
    minSurface: "Surface min", maxSurface: "Surface max",
    apply: "Appliquer", reset: "Réinitialiser",
    results: "résultats", result: "résultat",
    noResults: "Aucune annonce trouvée.",
    contactOwner: "Contacter", callNow: "Appeler", messageWhatsapp: "WhatsApp", message: "Message",
    requestVisit: "Demander une visite",
    verified: "Annonce vérifiée", postedOn: "Publiée le", justPosted: "à l'instant",
    daysAgo: (n) => `il y a ${n} jour${n > 1 ? "s" : ""}`,
    waVisitMsg: (ref, city) => `Bonjour, je souhaiterais organiser une visite de l'annonce ${ref} à ${city}. Quelles seraient vos disponibilités ?`,
    trustBadge: "Annonces contrôlées avant publication",
    forAgencies: "Pour les agences",
    valueProp: "Trouvez des annonces immobilières vérifiées en Algérie, ou contactez directement des agences de confiance.",
    postedBy: "Publié par", agency: "Agence", privateOwner: "Particulier",
    aboutProperty: "Description", keyInfo: "Caractéristiques", reference: "Référence",
    type: "Type", sale: "Vente", rentLabel: "Location",
    forSale: "À vendre", forRent: "À louer", perMonth: "/mois",
    back: "Retour",
    email: "Email", password: "Mot de passe", name: "Nom complet", phone: "Téléphone",
    role: "Vous êtes", noAccount: "Pas de compte ?", haveAccount: "Déjà inscrit ?",
    title: "Titre", description: "Description", price: "Prix (DA)", priceOnRequest: "Prix sur demande",
    transaction: "Transaction", city: "Ville", neighborhood: "Quartier",
    publish: "Publier", images: "URLs des images (séparées par virgule)",
    furnished: "Meublé", balcony: "Balcon", parking: "Parking",
    condition: "État", new: "Neuf", old: "Ancien",
    paymentType: "Paiement", cash: "Comptant", installment: "Facilité de paiement",
    titleDeed: "Acte notarié", landRegistry: "Livret foncier", negativeCert: "Certificat négatif",
    docAvailable: "Disponible", docUnavailable: "Indisponible", docNC: "Non communiqué",
    swimmingPool: "Piscine", garden: "Jardin",
    airConditioning: "Climatisation", heating: "Chauffage", elevator: "Ascenseur",
    floor: "Étage", orientation: "Orientation",
    listings: "Annonces", views: "vues",
    adminPanel: "Admin",
    eurNote: "Valeur approximative basée sur le taux officiel",
    uploadDrop: "Glissez vos photos ici",
    uploadBrowse: "ou cliquez pour parcourir",
    uploadHint: "JPG, PNG ou WebP · max 8 Mo · jusqu'à 10 photos",
    renewBanner: "Annonces à renouveler",
    renewSub: "Ces annonces ont plus de 30 jours. Sont-elles toujours disponibles ?",
    renew: "Renouveler", stillAvailable: "Toujours disponible",
    accountType: "Type de compte", agencyDesc: "Pour les agences immobilières",
    privateDesc: "Pour les particuliers",
    aboutUs: "À propos de Naydars", careers: "Carrières", press: "Presse",
    support: "Support", helpCenter: "Centre d'aide", privacyPolicy: "Politique de confidentialité",
    termsConditions: "Conditions générales",
    viewMore: "Voir plus", loadingMore: "Chargement…", endOfResults: "Fin des résultats",
    photos: "Photos", basicInfo: "Informations", priceLocation: "Prix & Localisation",
    documents: "Documents",
    quickListing: "Création rapide d'annonce", quickSub: "En moins de 2 minutes",
    features: "Caractéristiques",
    listView: "Liste", mapView: "Carte",
    similarProperties: "Annonces similaires",
    location_: "Localisation",
    statusActive: "Active", statusSold: "Vendu", statusRented: "Loué", statusInactive: "Désactivée",
    edit: "Modifier", delete: "Supprimer", markSold: "Marquer vendu", markRented: "Marquer loué",
    activate: "Activer", deactivate: "Désactiver",
    confirmDelete: "Supprimer cette annonce ?",
    welcomeBack: "Bon retour", manageListings: "Gérez vos annonces",
    addListing: "Nouvelle annonce", noListingsYet: "Vous n'avez pas encore d'annonce.",
    autocompleteHint: "Ville, quartier, référence…",
    footerAbout: "Naydars, la plateforme immobilière moderne d'Algérie.",
    footerLegal: "Tous droits réservés",
    popularCities: "Villes", popularTitle: "Explorer par ville", popularSub: "Toute l'Algérie",
    about: "À propos", help: "Aide", privacy: "Confidentialité", terms: "CGU",
    loading: "Chargement…",
    waMessage: (ref, city, price) => price
      ? `Bonjour, je suis intéressé(e) par l'annonce ${ref} à ${city}. Prix: ${price}.`
      : `Bonjour, je suis intéressé(e) par l'annonce ${ref}. Pourriez-vous me donner le prix et plus de détails ?`,
    admin: {
      title: "Admin Naydars",
      subtitle: (l, u) => `Gestion plateforme · ${l} annonces · ${u} utilisateurs`,
      tabListings: "Annonces", tabUsers: "Utilisateurs", tabSite: "Site",
      cleanupSeed: "Nettoyer données démo",
      cleanupConfirm: "Supprimer toutes les annonces de démonstration (seed) ? Cette action est irréversible.",
      cleanupSuccess: (n) => `${n} annonces de démo supprimées`,
      verify: "Vérifier", unverify: "Retirer vérification", verified: "Vérifiée",
      verifyTooltip: "Marquer comme annonce vérifiée",
      confirmDelete: "Supprimer cette annonce ?",
      confirmDeleteUser: "Supprimer cet utilisateur ?",
      roleUpdated: "Rôle mis à jour",
      accountActivated: "Compte activé", accountDeactivated: "Compte désactivé",
      deactivated: "Désactivé",
      stActive: "Active", stInactive: "Inactive", stSold: "Vendue", stRented: "Louée",
      rolePrivate: "Particulier", roleAgency: "Agence", roleAdmin: "Admin",
      siteHero: "Image de la page d'accueil",
      siteHeroDesc: "Téléversez une image hero (Baie d'Alger, Maqam Echahid, Grande Poste, etc.). Format paysage recommandé.",
      resetHero: "Réinitialiser à l'image par défaut",
      save: "Enregistrer", saved: "Configuration enregistrée",
    },
    agc: {
      badge: "Programme Partenaire Naydars",
      h1a: "Plus de clients sérieux.", h1b: "Moins de pertes de temps.",
      sub: "Naydars génère des contacts qualifiés pour votre agence immobilière en Algérie. Vos annonces sont vues par des acheteurs vraiment intéressés — qui vous contactent directement par WhatsApp.",
      ctaBecome: "Devenir Agence Partenaire", ctaWa: "Discuter sur WhatsApp",
      bullet1: "Sans engagement", bullet2: "Inscription en 2 minutes", bullet3: "Accès partenaire prioritaire",
      problemLabel: "Le constat", problemTitle: "Les agences perdent leur temps avec des contacts non qualifiés.",
      p1t: "Trop de curieux, pas assez d'acheteurs", p1b: "Les plateformes généralistes envoient des messages de personnes qui ne sont pas sérieuses ni prêtes à acheter.",
      p2t: "Manque de visibilité ciblée", p2b: "Vos annonces se perdent au milieu de milliers d'autres, sans distinction de qualité.",
      p3t: "Outils dépassés", p3b: "Interfaces lentes, sites mal optimisés mobile, contact compliqué — vos prospects abandonnent.",
      p4t: "Temps perdu au téléphone", p4b: "Vous passez des heures à filtrer des demandes au lieu de signer des mandats.",
      solLabel: "La solution Naydars", solTitle: "Des contacts qualifiés. Directement sur votre WhatsApp.",
      solDesc: "Naydars concentre les acheteurs sérieux d'Algérie sur une plateforme premium. Vos annonces sont mises en valeur, vos prospects vous contactent en un clic.",
      s1t: "Audience ciblée", s1b: "Des acheteurs qui cherchent activement en Algérie — pas des visiteurs occasionnels.",
      s2t: "Visibilité amplifiée", s2b: "Vos annonces apparaissent en premier dans les résultats des wilayas où vous opérez.",
      s3t: "Contact direct WhatsApp", s3b: "Le prospect vous écrit avec la référence de l'annonce, son intérêt, et son numéro. Plus de spam.",
      hwLabel: "Comment ça marche", hwTitle: "3 étapes, et vos premiers contacts arrivent.",
      hw1t: "Publiez vos annonces", hw1b: "Créez votre compte Agence en 2 minutes. Importez vos biens avec photos, prix, descriptifs. Notre équipe valide chaque annonce.",
      hw2t: "Les acheteurs découvrent", hw2b: "Vos annonces sont diffusées à des milliers d'acheteurs qualifiés via recherche, filtres et notifications.",
      hw3t: "Ils vous contactent", hw3b: "Le prospect clique sur WhatsApp ou appelle directement votre numéro. Plus d'intermédiaire, plus de perte d'info.",
      benLabel: "Bénéfices concrets", benTitle: "Ce que vous gagnez en rejoignant Naydars.",
      b1t: "Prospects qualifiés", b1b: "Audience filtrée, sérieuse, motivée.",
      b2t: "Demandes WhatsApp directes", b2b: "Préfilées avec la référence et le bien.",
      b3t: "Visibilité premium", b3b: "Mise en avant dans votre wilaya.",
      b4t: "Aucun setup technique", b4b: "Tout marche depuis un téléphone.",
      b5t: "Accès partenaire prioritaire", b5b: "Badge agence vérifiée affiché à vos prospects.",
      b6t: "Tableau de bord temps réel", b6b: "Suivez vos vues, vos contacts, vos performances.",
      trustTitle: "Une plateforme construite sur la confiance.",
      trustDesc: "Chaque annonce est contrôlée avant publication. Les agences sont vérifiées. Les acheteurs sont sérieux. C'est cette exigence qui fait la différence — et qui attire des prospects de qualité.",
      stat1a: "Annonces", stat1b: "vérifiées",
      stat2a: "Agences", stat2b: "certifiées",
      stat3a: "Acheteurs", stat3b: "qualifiés",
      finalBadge: "Places limitées — programme de lancement",
      finalTitle: "Rejoignez les premières agences partenaires de Naydars.",
      finalSub: "Profitez d'un accès prioritaire, d'une mise en avant gratuite pendant la phase de lancement, et de vos premiers contacts qualifiés dès la première semaine.",
      finalCta: "Discuter sur WhatsApp", finalCreate: "Créer un compte Agence",
    },
  },
  ar: {
    brand: "نيدارز", tagline: "العقار في الجزائر، ببساطة",
    heroTitle: "ابحث عن منزلك القادم",
    heroSub: "شقق، منازل وأراضٍ سكنية — في كامل الجزائر.",
    search: "بحث", buy: "شراء", rent: "إيجار",
    propertyType: "النوع", location: "الموقع", budget: "الميزانية القصوى",
    anyBudget: "كل الأسعار", allTypes: "كل الأنواع", allWilayas: "كل الجزائر",
    apartment: "شقة", house: "منزل", land: "أرض",
    featured: "مختارات نيدارز", featuredSub: "أبرز العقارات",
    viewAll: "عرض الكل", recentListings: "أحدث الإعلانات",
    whyUs: "لماذا نيدارز",
    trust1Title: "إعلانات موثوقة", trust1Desc: "كل إعلان يتم التحقق منه.",
    trust2Title: "تواصل مباشر", trust2Desc: "واتساب أو هاتف، دون وسيط.",
    trust3Title: "أسعار شفافة", trust3Desc: "بالدينار وما يعادله باليورو.",
    login: "تسجيل الدخول", register: "إنشاء حساب", logout: "خروج",
    postAd: "نشر إعلان", myAds: "إعلاناتي", dashboard: "لوحة التحكم",
    rooms: "غرف", bathrooms: "حمامات", surface: "المساحة",
    filters: "تصفية", minPrice: "السعر الأدنى", maxPrice: "السعر الأعلى",
    minSurface: "مساحة دنيا", maxSurface: "مساحة قصوى",
    apply: "تطبيق", reset: "إعادة",
    results: "نتيجة", result: "نتيجة",
    noResults: "لا توجد نتائج.",
    contactOwner: "تواصل", callNow: "اتصال", messageWhatsapp: "واتساب", message: "رسالة",
    requestVisit: "طلب زيارة",
    verified: "إعلان موثق", postedOn: "نُشر في", justPosted: "الآن",
    daysAgo: (n) => `قبل ${n} يوم`,
    waVisitMsg: (ref, city) => `مرحبا، أود تنظيم زيارة للعقار ${ref} في ${city}. ما هي أوقات توفركم؟`,
    trustBadge: "إعلانات تم التحقق منها قبل النشر",
    forAgencies: "للوكالات",
    valueProp: "اكتشف إعلانات عقارية موثقة في الجزائر، أو تواصل مباشرة مع وكالات معتمدة.",
    postedBy: "نشر بواسطة", agency: "وكالة", privateOwner: "شخصي",
    aboutProperty: "الوصف", keyInfo: "الخصائص", reference: "المرجع",
    type: "النوع", sale: "بيع", rentLabel: "إيجار",
    forSale: "للبيع", forRent: "للإيجار", perMonth: "/شهر",
    back: "رجوع",
    email: "البريد", password: "كلمة المرور", name: "الاسم", phone: "الهاتف",
    role: "أنت", noAccount: "لا تملك حساباً؟", haveAccount: "لديك حساب؟",
    title: "العنوان", description: "الوصف", price: "السعر (دج)", priceOnRequest: "السعر عند الطلب",
    transaction: "المعاملة", city: "المدينة", neighborhood: "الحي",
    publish: "نشر", images: "روابط الصور (مفصولة بفاصلة)",
    furnished: "مفروش", balcony: "شرفة", parking: "موقف",
    condition: "الحالة", new: "جديد", old: "قديم",
    paymentType: "الدفع", cash: "نقدا", installment: "تسهيلات",
    titleDeed: "عقد موثق", landRegistry: "دفتر عقاري", negativeCert: "شهادة سلبية",
    docAvailable: "متوفر", docUnavailable: "غير متوفر", docNC: "غير محدد",
    swimmingPool: "مسبح", garden: "حديقة",
    airConditioning: "تكييف", heating: "تدفئة", elevator: "مصعد",
    floor: "الطابق", orientation: "الاتجاه",
    listings: "الإعلانات", views: "مشاهدة",
    adminPanel: "إدارة",
    eurNote: "قيمة تقريبية بناءً على سعر الصرف الرسمي",
    uploadDrop: "اسحب صورك هنا", uploadBrowse: "أو انقر للتصفح",
    uploadHint: "JPG، PNG أو WebP · حد أقصى 8 ميغا · حتى 10 صور",
    renewBanner: "إعلانات تحتاج تجديد",
    renewSub: "هذه الإعلانات مر عليها أكثر من 30 يوم.",
    renew: "تجديد", stillAvailable: "لا يزال متوفراً",
    accountType: "نوع الحساب", agencyDesc: "للوكالات العقارية", privateDesc: "للأفراد",
    aboutUs: "حول نيدارز", careers: "وظائف", press: "الصحافة",
    support: "الدعم", helpCenter: "مركز المساعدة", privacyPolicy: "سياسة الخصوصية",
    termsConditions: "الشروط والأحكام",
    viewMore: "المزيد", loadingMore: "جارٍ التحميل…", endOfResults: "نهاية النتائج",
    photos: "الصور", basicInfo: "المعلومات", priceLocation: "السعر والموقع",
    documents: "الوثائق",
    quickListing: "نشر سريع للإعلان", quickSub: "في أقل من دقيقتين",
    features: "الخصائص",
    listView: "قائمة", mapView: "خريطة",
    similarProperties: "إعلانات مشابهة",
    location_: "الموقع",
    statusActive: "نشط", statusSold: "مباع", statusRented: "مؤجر", statusInactive: "معطل",
    edit: "تعديل", delete: "حذف", markSold: "بيع", markRented: "إيجار",
    activate: "تفعيل", deactivate: "تعطيل",
    confirmDelete: "حذف هذا الإعلان؟",
    welcomeBack: "مرحبا بعودتك", manageListings: "إدارة إعلاناتك",
    addListing: "إعلان جديد", noListingsYet: "لا توجد إعلانات بعد.",
    autocompleteHint: "مدينة، حي، مرجع…",
    footerAbout: "نيدارز، منصة العقارات الحديثة في الجزائر.",
    footerLegal: "جميع الحقوق محفوظة",
    popularCities: "المدن", popularTitle: "استكشف حسب المدينة", popularSub: "كل الجزائر",
    about: "حول", help: "مساعدة", privacy: "الخصوصية", terms: "الشروط",
    loading: "جارٍ التحميل…",
    waMessage: (ref, city, price) => price
      ? `مرحبا، أنا مهتم بالإعلان ${ref} في ${city}. السعر: ${price}.`
      : `مرحبا، أنا مهتم بالإعلان ${ref}. هل يمكنكم تزويدي بالسعر والمزيد من التفاصيل؟`,
    admin: {
      title: "إدارة نيدارز",
      subtitle: (l, u) => `إدارة المنصة · ${l} إعلان · ${u} مستخدم`,
      tabListings: "الإعلانات", tabUsers: "المستخدمون", tabSite: "الموقع",
      cleanupSeed: "حذف بيانات العرض التوضيحي",
      cleanupConfirm: "هل تريد حذف جميع الإعلانات التجريبية؟ هذا الإجراء لا يمكن التراجع عنه.",
      cleanupSuccess: (n) => `تم حذف ${n} إعلانات تجريبية`,
      verify: "توثيق", unverify: "إلغاء التوثيق", verified: "موثقة",
      verifyTooltip: "وضع علامة كإعلان موثق",
      confirmDelete: "حذف هذا الإعلان؟",
      confirmDeleteUser: "حذف هذا المستخدم؟",
      roleUpdated: "تم تحديث الدور",
      accountActivated: "تم تفعيل الحساب", accountDeactivated: "تم تعطيل الحساب",
      deactivated: "معطل",
      stActive: "نشط", stInactive: "معطل", stSold: "مباع", stRented: "مؤجر",
      rolePrivate: "فرد", roleAgency: "وكالة", roleAdmin: "مدير",
      siteHero: "صورة الصفحة الرئيسية",
      siteHeroDesc: "ارفع صورة رئيسية (خليج الجزائر، مقام الشهيد، البريد الكبير، إلخ). تنسيق أفقي مفضل.",
      resetHero: "العودة إلى الصورة الافتراضية",
      save: "حفظ", saved: "تم حفظ الإعدادات",
    },
    agc: {
      badge: "برنامج شركاء نيدارز",
      h1a: "المزيد من العملاء الجادين.", h1b: "أقل من إضاعة الوقت.",
      sub: "نيدارز يولد جهات اتصال مؤهلة لوكالتك العقارية في الجزائر. إعلاناتك تُشاهد من قبل مشترين جادين — يتواصلون معك مباشرة عبر واتساب.",
      ctaBecome: "كن وكالة شريكة", ctaWa: "تحدث عبر واتساب",
      bullet1: "بدون التزام", bullet2: "تسجيل في دقيقتين", bullet3: "وصول شريك ذو أولوية",
      problemLabel: "الواقع", problemTitle: "الوكالات تضيع وقتها مع جهات اتصال غير مؤهلة.",
      p1t: "الكثير من الفضوليين، القليل من المشترين", p1b: "المنصات العامة ترسل رسائل من أشخاص غير جادين وغير مستعدين للشراء.",
      p2t: "نقص في الرؤية المستهدفة", p2b: "إعلاناتك تضيع وسط الآلاف من الإعلانات الأخرى دون تمييز للجودة.",
      p3t: "أدوات قديمة", p3b: "واجهات بطيئة، مواقع غير محسنة للهاتف، تواصل معقد — العملاء المحتملون يستسلمون.",
      p4t: "وقت ضائع على الهاتف", p4b: "تقضي ساعات في فلترة الطلبات بدلاً من توقيع العقود.",
      solLabel: "حل نيدارز", solTitle: "جهات اتصال مؤهلة. مباشرة على واتساب الخاص بك.",
      solDesc: "نيدارز يجمع المشترين الجادين في الجزائر على منصة متميزة. إعلاناتك تُبرز، وعملاؤك المحتملون يتواصلون معك بنقرة واحدة.",
      s1t: "جمهور مستهدف", s1b: "مشترون يبحثون فعلياً في الجزائر — لا زوار عابرون.",
      s2t: "رؤية معززة", s2b: "إعلاناتك تظهر أولاً في نتائج الولايات التي تعمل بها.",
      s3t: "تواصل مباشر عبر واتساب", s3b: "العميل المحتمل يكتب لك بمرجع الإعلان واهتمامه ورقمه. لا مزيد من الرسائل المزعجة.",
      hwLabel: "كيف يعمل", hwTitle: "3 خطوات، وتصلك أولى جهات الاتصال.",
      hw1t: "انشر إعلاناتك", hw1b: "أنشئ حساب الوكالة في دقيقتين. ارفع عقاراتك بصور وأسعار ووصف. فريقنا يراجع كل إعلان.",
      hw2t: "المشترون يكتشفون", hw2b: "إعلاناتك تنتشر لآلاف المشترين المؤهلين عبر البحث والتصفية والإشعارات.",
      hw3t: "يتواصلون معك", hw3b: "العميل ينقر على واتساب أو يتصل بك مباشرة. لا وسطاء، لا فقدان للمعلومات.",
      benLabel: "فوائد ملموسة", benTitle: "ما تكسبه بالانضمام إلى نيدارز.",
      b1t: "عملاء مؤهلون", b1b: "جمهور مفلتر، جاد، متحفز.",
      b2t: "طلبات واتساب مباشرة", b2b: "مع المرجع والعقار.",
      b3t: "رؤية متميزة", b3b: "إبراز في ولايتك.",
      b4t: "بدون إعداد تقني", b4b: "كل شيء يعمل من الهاتف.",
      b5t: "وصول شريك ذو أولوية", b5b: "شارة وكالة موثقة معروضة لعملائك.",
      b6t: "لوحة تحكم لحظية", b6b: "تابع مشاهداتك واتصالاتك وأداءك.",
      trustTitle: "منصة مبنية على الثقة.",
      trustDesc: "كل إعلان يُراجع قبل النشر. الوكالات موثقة. المشترون جادون. هذا التميز يصنع الفرق — ويجذب عملاء بجودة عالية.",
      stat1a: "إعلانات", stat1b: "موثقة",
      stat2a: "وكالات", stat2b: "معتمدة",
      stat3a: "مشترون", stat3b: "مؤهلون",
      finalBadge: "أماكن محدودة — برنامج الإطلاق",
      finalTitle: "انضم إلى أول الوكالات الشريكة لنيدارز.",
      finalSub: "استفد من وصول ذي أولوية، إبراز مجاني خلال مرحلة الإطلاق، وأول جهات اتصالك المؤهلة منذ الأسبوع الأول.",
      finalCta: "تحدث عبر واتساب", finalCreate: "إنشاء حساب وكالة",
    },
  },
  en: {
    brand: "Naydars", tagline: "Algerian real estate, simplified",
    heroTitle: "Find your next home",
    heroSub: "Apartments, villas, houses and residential land — across Algeria.",
    search: "Search", buy: "Buy", rent: "Rent",
    propertyType: "Type", location: "Location", budget: "Max budget",
    anyBudget: "Any price", allTypes: "All types", allWilayas: "All Algeria",
    apartment: "Apartment", house: "House", land: "Land",
    featured: "Naydars Picks", featuredSub: "Most remarkable properties",
    viewAll: "View all", recentListings: "Latest listings",
    whyUs: "Why Naydars",
    trust1Title: "Verified listings", trust1Desc: "Every listing reviewed before publication.",
    trust2Title: "Direct contact", trust2Desc: "WhatsApp or phone, no middleman.",
    trust3Title: "Transparent pricing", trust3Desc: "DA pricing with EUR equivalent.",
    login: "Sign in", register: "Sign up", logout: "Sign out",
    postAd: "Post ad", myAds: "My listings", dashboard: "Dashboard",
    rooms: "Rooms", bathrooms: "Baths", surface: "Surface",
    filters: "Filters", minPrice: "Min price", maxPrice: "Max price",
    minSurface: "Min surface", maxSurface: "Max surface",
    apply: "Apply", reset: "Reset",
    results: "results", result: "result",
    noResults: "No listings found.",
    contactOwner: "Contact", callNow: "Call", messageWhatsapp: "WhatsApp", message: "Message",
    requestVisit: "Request a visit",
    verified: "Verified listing", postedOn: "Posted on", justPosted: "just now",
    daysAgo: (n) => `${n} day${n > 1 ? "s" : ""} ago`,
    waVisitMsg: (ref, city) => `Hello, I'd like to schedule a visit for listing ${ref} in ${city}. What are your available times?`,
    trustBadge: "Listings reviewed for quality before publication",
    forAgencies: "For agencies",
    valueProp: "Find verified real estate listings in Algeria, or connect directly with trusted agencies.",
    postedBy: "Posted by", agency: "Agency", privateOwner: "Private",
    aboutProperty: "Description", keyInfo: "Features", reference: "Reference",
    type: "Type", sale: "Sale", rentLabel: "Rent",
    forSale: "For sale", forRent: "For rent", perMonth: "/mo",
    back: "Back",
    email: "Email", password: "Password", name: "Full name", phone: "Phone",
    role: "You are", noAccount: "No account?", haveAccount: "Already have an account?",
    title: "Title", description: "Description", price: "Price (DA)", priceOnRequest: "Price on request",
    transaction: "Transaction", city: "City", neighborhood: "Neighborhood",
    publish: "Publish", images: "Image URLs (comma-separated)",
    furnished: "Furnished", balcony: "Balcony", parking: "Parking",
    condition: "Condition", new: "New", old: "Old",
    paymentType: "Payment", cash: "Cash", installment: "Installments",
    titleDeed: "Title deed", landRegistry: "Land registry", negativeCert: "Negative certificate",
    docAvailable: "Available", docUnavailable: "Unavailable", docNC: "Not specified",
    swimmingPool: "Swimming pool", garden: "Garden",
    airConditioning: "Air conditioning", heating: "Heating", elevator: "Elevator",
    floor: "Floor", orientation: "Orientation",
    listings: "Listings", views: "views",
    adminPanel: "Admin",
    eurNote: "Approximate value based on official exchange rate",
    uploadDrop: "Drop your photos here", uploadBrowse: "or click to browse",
    uploadHint: "JPG, PNG or WebP · max 8MB · up to 10 photos",
    renewBanner: "Listings to renew",
    renewSub: "These listings are over 30 days old. Are they still available?",
    renew: "Renew", stillAvailable: "Still available",
    accountType: "Account type", agencyDesc: "For real estate agencies", privateDesc: "For private individuals",
    aboutUs: "About Naydars", careers: "Careers", press: "Press",
    support: "Support", helpCenter: "Help Center", privacyPolicy: "Privacy Policy",
    termsConditions: "Terms & Conditions",
    viewMore: "View more", loadingMore: "Loading…", endOfResults: "End of results",
    photos: "Photos", basicInfo: "Information", priceLocation: "Price & Location",
    documents: "Documents",
    quickListing: "Quick listing", quickSub: "In less than 2 minutes",
    features: "Features",
    listView: "List", mapView: "Map",
    similarProperties: "Similar properties",
    location_: "Location",
    statusActive: "Active", statusSold: "Sold", statusRented: "Rented", statusInactive: "Inactive",
    edit: "Edit", delete: "Delete", markSold: "Mark sold", markRented: "Mark rented",
    activate: "Activate", deactivate: "Deactivate",
    confirmDelete: "Delete this listing?",
    welcomeBack: "Welcome back", manageListings: "Manage your listings",
    addListing: "New listing", noListingsYet: "You don't have any listings yet.",
    autocompleteHint: "City, neighborhood, reference…",
    footerAbout: "Naydars, the modern real estate platform of Algeria.",
    footerLegal: "All rights reserved",
    popularCities: "Cities", popularTitle: "Explore by city", popularSub: "All Algeria",
    about: "About", help: "Help", privacy: "Privacy", terms: "Terms",
    loading: "Loading…",
    waMessage: (ref, city, price) => price
      ? `Hello, I'm interested in listing ${ref} in ${city}. Price: ${price}.`
      : `Hello, I'm interested in listing ${ref}. Could you share the price and more details?`,
    admin: {
      title: "Naydars Admin",
      subtitle: (l, u) => `Platform management · ${l} listings · ${u} users`,
      tabListings: "Listings", tabUsers: "Users", tabSite: "Site",
      cleanupSeed: "Clean demo data",
      cleanupConfirm: "Delete all demo (seed) listings? This action is irreversible.",
      cleanupSuccess: (n) => `${n} demo listings deleted`,
      verify: "Verify", unverify: "Unverify", verified: "Verified",
      verifyTooltip: "Mark as verified listing",
      confirmDelete: "Delete this listing?",
      confirmDeleteUser: "Delete this user?",
      roleUpdated: "Role updated",
      accountActivated: "Account activated", accountDeactivated: "Account deactivated",
      deactivated: "Deactivated",
      stActive: "Active", stInactive: "Inactive", stSold: "Sold", stRented: "Rented",
      rolePrivate: "Private", roleAgency: "Agency", roleAdmin: "Admin",
      siteHero: "Homepage hero image",
      siteHeroDesc: "Upload a hero image (Bay of Algiers, Maqam Echahid, Grande Poste, etc.). Landscape format recommended.",
      resetHero: "Reset to default image",
      save: "Save", saved: "Configuration saved",
    },
    agc: {
      badge: "Naydars Partner Program",
      h1a: "More serious clients.", h1b: "Less wasted time.",
      sub: "Naydars generates qualified leads for your real estate agency in Algeria. Your listings are seen by genuinely interested buyers — who contact you directly via WhatsApp.",
      ctaBecome: "Become a Partner Agency", ctaWa: "Chat on WhatsApp",
      bullet1: "No commitment", bullet2: "Sign up in 2 minutes", bullet3: "Priority partner access",
      problemLabel: "The reality", problemTitle: "Agencies waste their time on unqualified contacts.",
      p1t: "Too many curious, not enough buyers", p1b: "Generic platforms send messages from people who aren't serious or ready to buy.",
      p2t: "Lack of targeted visibility", p2b: "Your listings get lost among thousands of others, with no quality distinction.",
      p3t: "Outdated tools", p3b: "Slow interfaces, poorly optimized mobile sites, complicated contact — your leads give up.",
      p4t: "Time wasted on the phone", p4b: "You spend hours filtering requests instead of signing mandates.",
      solLabel: "The Naydars solution", solTitle: "Qualified leads. Directly on your WhatsApp.",
      solDesc: "Naydars concentrates serious Algerian buyers on a premium platform. Your listings stand out, your leads contact you in one click.",
      s1t: "Targeted audience", s1b: "Buyers actively searching in Algeria — not casual visitors.",
      s2t: "Amplified visibility", s2b: "Your listings appear first in the results of wilayas you operate in.",
      s3t: "Direct WhatsApp contact", s3b: "The lead writes to you with the listing reference, their interest and their number. No more spam.",
      hwLabel: "How it works", hwTitle: "3 steps, and your first leads arrive.",
      hw1t: "Post your listings", hw1b: "Create your Agency account in 2 minutes. Import your properties with photos, prices, descriptions. Our team validates each listing.",
      hw2t: "Buyers discover", hw2b: "Your listings reach thousands of qualified buyers via search, filters and notifications.",
      hw3t: "They contact you", hw3b: "The lead clicks WhatsApp or calls your number directly. No middleman, no lost info.",
      benLabel: "Concrete benefits", benTitle: "What you gain by joining Naydars.",
      b1t: "Qualified leads", b1b: "Filtered, serious, motivated audience.",
      b2t: "Direct WhatsApp requests", b2b: "Prefilled with reference and property.",
      b3t: "Premium visibility", b3b: "Featured in your wilaya.",
      b4t: "No technical setup", b4b: "Everything works from a phone.",
      b5t: "Priority partner access", b5b: "Verified agency badge shown to your leads.",
      b6t: "Real-time dashboard", b6b: "Track your views, contacts, performance.",
      trustTitle: "A platform built on trust.",
      trustDesc: "Every listing is reviewed before publication. Agencies are verified. Buyers are serious. This standard makes the difference — and attracts quality leads.",
      stat1a: "Listings", stat1b: "verified",
      stat2a: "Agencies", stat2b: "certified",
      stat3a: "Buyers", stat3b: "qualified",
      finalBadge: "Limited spots — launch program",
      finalTitle: "Join the first Naydars partner agencies.",
      finalSub: "Enjoy priority access, free featured placement during launch, and your first qualified leads within the first week.",
      finalCta: "Chat on WhatsApp", finalCreate: "Create an Agency account",
    },
  },
};

export const formatDA = (n) => n || n === 0 ? new Intl.NumberFormat("fr-FR").format(n) + " DA" : "";
export const formatEUR = (da, rate) => !da || !rate ? "" : "≈ " + new Intl.NumberFormat("fr-FR").format(Math.round(da / rate)) + " €";
